import { tag } from '../../tokens/component/tag';

const sizeStyle = (theme, key) => {
    const dims = {
        sm: {
            height:   theme.spacing(3.5),                 // 14px
            minWidth: theme.spacing('lg'),                // 24px
            fontSize: theme.typography.body2.fontSize,    // 10.8px
            padding:  theme.spacing(0.5, 1.5),            // 2px 6px
            iconSize: theme.spacing('xs'),                // 12px
        },
        md: {
            height:   theme.spacing('sm'),                // 16px
            minWidth: theme.spacing('xl'),                // 28px
            fontSize: theme.typography.caption.fontSize,  // 12px
            padding:  theme.spacing(0.5, 'xxs'),          // 2px 8px
            iconSize: theme.spacing(3.5),                 // 14px
        },
        lg: {
            height:   theme.spacing('md'),                // 20px
            minWidth: theme.spacing('xxl'),               // 32px
            fontSize: theme.typography.body1.fontSize,    // 14px
            padding:  theme.spacing('tiny', 'xxs'),       // 4px 8px
            iconSize: theme.spacing('sm'),                // 16px
        },
    }[key];

    return {
        height: dims.height,
        minWidth: dims.minWidth,
        fontSize: dims.fontSize,
        padding: dims.padding,
        '& .MuiChip-deleteIcon': {
            fontSize: dims.iconSize,
        },
    };
};

const MuiChip = {
    defaultProps: {
        size: 'large',
    },
    styleOverrides: {
        root: ({ theme }) => ({
            backgroundColor: tag.color.chip.default.bg,
            color: theme.palette.text.primary,
            borderRadius: theme.radius.full,
            fontWeight: theme.typography.fontWeightRegular,
            gap: theme.spacing('tiny'),               // 4px
            lineHeight: 1,
        }),
        label: ({ theme }) => ({
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(0.5),              // 2px between the label prefix and value
            // Muted "Label:" prefix shown before the value in labeled selection chips
            '& .chip-prefix': {
                color: theme.palette.text.secondary,
            },
        }),
        deleteIcon: () => ({
            color: tag.color.chip.default.button,
            margin: 0,
            '&:hover': {
                color: tag.color.chip.default.button,
            },
        }),
        sizeSmall: ({ theme }) => sizeStyle(theme, 'sm'),
        sizeMedium: ({ theme }) => sizeStyle(theme, 'md'),
        sizeLarge: ({ theme }) => sizeStyle(theme, 'lg'),
        colorError: ({ theme }) => ({
            backgroundColor: theme.palette.error[200],
            color: theme.palette.error[700],
            '& .chip-prefix': {
                color: tag.color.chip.error.label,
            },
            '& .MuiChip-deleteIcon': {
                color: theme.palette.error[700],
                '&:hover': {
                    color: theme.palette.error[700],
                },
            },
        }),
    },
};

export default MuiChip;
